/** Treat blank and literal "0" media fields as absent. */
export function readRowMediaText(
  rows: Array<Record<string, unknown>>,
  field: string,
): string | null {
  for (const row of rows) {
    const value = String(row[field] ?? "").trim();
    if (value.length > 0 && value !== "0") return value;
  }
  return null;
}
